"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationDeliveryMethodLabels = exports.NotificationDeliveryMethod = exports.NotificationDeliveryMethods = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.NotificationDeliveryMethods = ['SMS', 'EMAIL'];
exports.NotificationDeliveryMethod = typebox_1.Type.Union(exports.NotificationDeliveryMethods.map((method) => typebox_1.Type.Literal(method)));
exports.NotificationDeliveryMethodLabels = {
    SMS: 'SMS',
    EMAIL: 'Email',
};
//# sourceMappingURL=notification-delivery-method.js.map